import $constants from './constants'
import $console   from './console'
import $company   from './company'
import axios      from './axios'
import $lodash    from 'lodash'


let instaled = false

// Plugin install
const install = Vue => {

    if (instaled) return // Plugin já foi instalado

    Object.defineProperties(Vue.prototype, {
        $console: {
            get() {
                return $console
            }
        },
        $company: {
            get() {
                return $company
            }
        },
        $axios: {
            get() {
                return axios
            }
        },
        $lodash: {
            get() {
                return $lodash
            }
        },
        $constants: {
            get() {
                return $constants
            }
        },
    })

    instaled = true
}

export default install